import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/header';
import Footer from '../components/footer';
import './case-study-page.css';
import { useTranslation } from "react-i18next";

const CaseStudyAutomotive = ({ showCalModal }) => {
    const { t } = useTranslation();

    const footerMenuItems = [
        <a href="/#home-section-home"><span className="Large">{t("footer_menu-home")}</span></a>,
        <a href="/#problems-solutions"><span className="Large">{t("footer_menu-problems-solutions")}</span></a>,
        <a href="/#profile-section"><span className="Large">{t("footer_menu-about-me")}</span></a>,
        <a href="/legal"><span className="Large">{t("footer_menu-impressum")}</span></a>,
        <a href="/privacy"><span className="Large">{t("footer_menu-privacy")}</span></a>
    ];

    return (
        <div className="case-study-container">
            <Helmet>
                <title>{t("case-study_automotive_title")}</title>
                <meta name="description" content={t("case-study_automotive_meta-description")} />
                <meta property="og:title" content={t("case-study_automotive_title")} />
                <meta property="og:description" content={t("case-study_automotive_meta-description")} />
            </Helmet>

            <Header showCalModal={showCalModal} />

            <section className="case-study-hero">
                <h1 className="case-study-title">{t("case-study_automotive_title")}</h1>
            </section>

            <main className="case-study-content">
                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_automotive_overview-title")}</h2>
                    <p className="case-study-body">{t("case-study_automotive_overview-text")}</p>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_automotive_challenges-title")}</h2>


                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_automotive_microservices-title")}</h3>
                        <p className="case-study-body">{t("case-study_automotive_microservices-text")}</p>
                        <p className="case-study-body"><strong>{t("case-study_automotive_why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study_automotive_microservices-benefit-1")}</li>
                            <li>{t("case-study_automotive_microservices-benefit-2")}</li>
                        </ul>
                    </article>

                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_automotive_kubernetes-title")}</h3>
                        <p className="case-study-body">{t("case-study_automotive_kubernetes-text")}</p>
                        <p className="case-study-body"><strong>{t("case-study_automotive_why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study_automotive_kubernetes-benefit-1")}</li>
                            <li>{t("case-study_automotive_kubernetes-benefit-2")}</li>
                        </ul>
                    </article>

                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_automotive_test-qa-title")}</h3>
                        <p className="case-study-body">{t("case-study_automotive_test-qa-text")}</p>
                        <p className="case-study-body"><strong>{t("case-study_automotive_why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study_automotive_test-qa-benefit-1")}</li>
                            <li>{t("case-study_automotive_test-qa-benefit-2")}</li>
                        </ul>
                    </article>

                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_automotive_scalable-frontend-title")}</h3>
                        <p className="case-study-body">{t("case-study_automotive_scalable-frontend-text")}</p>
                        <p className="case-study-body"><strong>{t("case-study_automotive_why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study_automotive_scalable-frontend-benefit-1")}</li>
                            <li>{t("case-study_automotive_scalable-frontend-benefit-2")}</li>
                        </ul>
                    </article>

                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_automotive_event-sourcing-title")}</h3>
                        <p className="case-study-body">{t("case-study_automotive_event-sourcing-text")}</p>
                        <p className="case-study-body"><strong>{t("case-study_automotive_why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study_automotive_event-sourcing-benefit-1")}</li>
                            <li>{t("case-study_automotive_event-sourcing-benefit-2")}</li>
                        </ul>
                    </article>

                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_automotive_ci-cd-title")}</h3>
                        <p className="case-study-body">{t("case-study_automotive_ci-cd-text")}</p>
                        <p className="case-study-body"><strong>{t("case-study_automotive_why")}</strong></p>
                        <ul className="case-study-body">
                            <li>{t("case-study_automotive_ci-cd-benefit-1")}</li>
                            <li>{t("case-study_automotive_ci-cd-benefit-2")}</li>
                        </ul>
                    </article>

                    <div className={"image-container"}>
                        <div className={"image"}>
                            <img src={"/Micro_service_event_store_architecture.png"}/>
                        </div>
                    </div>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_automotive_results-title")}</h2>
                    <ul className="case-study-body">
                    <li>✅ {t("case-study_automotive_results-point-1")}</li>
                        <li>✅ {t("case-study_automotive_results-point-2")}</li>
                        <li>✅ {t("case-study_automotive_results-point-3")}</li>
                        <li>✅ {t("case-study_automotive_results-point-4")}</li>
                        <li>✅ {t("case-study_automotive_results-point-5")}</li>
                    </ul>
                </section>

                <section className="case-study-section">
                <h2 className="case-study-section-title">{t("case-study_automotive_conclusion-title")}</h2>
                    <p className="case-study-body">{t("case-study_automotive_conclusion-text-1")}</p>
                    <p className="case-study-body">{t("case-study_automotive_conclusion-text-2")}</p>
                </section>
            </main>

            <Footer footerMenuItems={footerMenuItems}/>
        </div>
    );
};

export default CaseStudyAutomotive;
